import { useRoutes } from 'react-router-dom'
import routes from './router'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import ThemeProvider from './theme/ThemeProvider'
import { Alert, CssBaseline, Snackbar } from '@mui/material'
import { Web3ContextProvider } from './contexts/web3Context'
import { SnackbarContext } from './contexts/SnackbarContext'
import { useState } from 'react'

const App = (): JSX.Element => {
  const content = useRoutes(routes)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [color, setColor] = useState('')

  return (
    <ThemeProvider>
      <Web3ContextProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarContext.Provider value={{ open, message, color, setOpen, setMessage, setColor }}>
            <CssBaseline />
            {content}
            <Snackbar
              open={open}
              autoHideDuration={3000}
              onClose={() => {
                return
              }}
              message={message}
              color={color}
            >
              {/*@ts-ignore*/}
              <Alert onClose={() => setOpen(false)} severity="error" sx={{ width: '100%' }}>
                {message}
              </Alert>
            </Snackbar>
          </SnackbarContext.Provider>
        </LocalizationProvider>
      </Web3ContextProvider>
    </ThemeProvider>
  )
}
export default App
